import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { corporateClientsAPI } from "api/api/corporateClientsApi/corporateClientsApi";
import { GetCorporateClientsExcelByMarathonIdParams } from "api/api/corporateClientsApi/types";

export const getCorporateClientsExcelByMarathonId = createAsyncThunk<
  void,
  GetCorporateClientsExcelByMarathonIdParams
>(
  `statuses/getCorporateClientsExcelByMarathonId`,
  async (params, { rejectWithValue }) => {
    try {
      const data = await corporateClientsAPI.getCorporateClientsExcelByMarathonId(params);
      return data;
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error(
          "Error while getting statuses comments",
          error?.response?.data
        );
        return rejectWithValue(error?.response?.data || "Unknown error");
      } else {
        console.error("Error while getting statuses comments", error);
        return rejectWithValue(
          "Что-то пошло не так... Попробуйте обновить страницу"
        );
      }
    }
  }
);